import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, CheckCircle2 } from "lucide-react";
import { SERVICE_OPTIONS } from "./data";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const field =
  "w-full rounded-lg bg-[#171B22] border border-[#9AA3AF]/25 px-4 py-3 text-white placeholder:text-[#9AA3AF]/60 focus:outline-none focus:border-[#C9A44C] transition-colors duration-300";

export default function QuoteForm({ onDone, idPrefix = "quote" }) {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
    service: "Cooling",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone || !form.email || !form.address) {
      toast.error("Please fill in your name, phone, email, and address.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/quote`, form);
      setDone(true);
      toast.success("Request sent. We will be in touch shortly.");
      onDone && onDone();
    } catch (err) {
      toast.error("Something went wrong. Please call us at 512-740-4818.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div data-testid={`${idPrefix}-success`} className="text-center py-10">
        <CheckCircle2 className="mx-auto text-[#C9A44C]" size={48} />
        <h4 className="mt-4 text-2xl text-white">Thank you.</h4>
        <p className="mt-2 text-[#9AA3AF]">
          Your quote request is on its way to our team. We will reach out shortly.
        </p>
      </div>
    );
  }

  return (
    <form data-testid={`${idPrefix}-form`} onSubmit={submit} className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <input data-testid={`${idPrefix}-name`} className={field} placeholder="Full name" value={form.name} onChange={set("name")} />
        <input data-testid={`${idPrefix}-phone`} className={field} placeholder="Phone" value={form.phone} onChange={set("phone")} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <input data-testid={`${idPrefix}-email`} type="email" className={field} placeholder="Email" value={form.email} onChange={set("email")} />
        <input data-testid={`${idPrefix}-address`} className={field} placeholder="Service address or ZIP" value={form.address} onChange={set("address")} />
      </div>
      <select data-testid={`${idPrefix}-service`} className={field} value={form.service} onChange={set("service")}>
        {SERVICE_OPTIONS.map((o) => (
          <option key={o} value={o} className="bg-[#171B22]">
            {o}
          </option>
        ))}
      </select>
      <textarea
        data-testid={`${idPrefix}-message`}
        className={`${field} min-h-[110px] resize-none`}
        placeholder="Tell us what you need (optional)"
        value={form.message}
        onChange={set("message")}
      />
      <button
        data-testid={`${idPrefix}-submit`}
        type="submit"
        disabled={loading}
        className="focus-gold w-full py-4 rounded-full font-bold bg-[#C9A44C] text-[#171B22] hover:bg-[#D6B15A] transition-colors duration-300 disabled:opacity-70 inline-flex items-center justify-center gap-2"
      >
        {loading ? <><Loader2 className="animate-spin" size={18} /> Sending...</> : "Request a Quote"}
      </button>
    </form>
  );
}
